import axios from "axios";
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
});

const postData = {
    grant_type: "client_credentials",
    client_id: process.env.VUE_APP_API_CLIENT_ID,
    scope: "*",
    client_secret: process.env.VUE_APP_API_CLIENT_SECRET
};

export default {
    getToken(context) {
        return new Promise((resolve, reject) => {
            apiClient
                .post("/oauth/token", postData)
                .then(response => {
                    const token = response.data.access_token;
                    localStorage.setItem("degree_token", token);
                    context.commit("SET_TOKEN", token);
                    resolve(response);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }
};
